import { IPromise } from 'angular';
import { assert } from 'console';
import { call, CallEffect, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import {
  DatabaseDefinition,
  DatasourceDefinition,
  ExplorableItemDefinitions,
  ProjectDefinition,
  TableDefinition
} from '../../../../ts/models/ContentDefinitions';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IProjectInfo } from '../../../../ts/models/IProjectInfo';
import { IWorkbookInfo } from '../../../../ts/models/IWorkbookInfo';
import { Set } from '../../../../ts/models/Set';
import { ExploreContentApi_ContentType } from '../../../../ts/ServerApi/types/IContent';
import { EditPermissionsAction } from '../../../../ts/services/EditPermissionsAction';
import { SetContentPermissions } from '../../../actions/AppActionTypes';
import { requestFailed, RequestFailedAction } from '../../../actions/RequestFailedAction';
import { SetContentPermissionsAction } from '../../../actions/spaces/SetContentPermissionsActions';
import { ServiceLocator } from '../../../ServiceLocator';
import { getDatabases, getProjectInfos, replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';

export function openPermissionsDialog(content: IContentInfo[], contentType: ExploreContentApi_ContentType): IPromise<any> {
  const service = ServiceLocator.get<EditPermissionsAction>('EditPermissionsAction');
  const context = ServiceLocator.getAngularActionContext();

  return service.showEditPermissionsDialog(Set.fromIdItemArray(content), contentType, context);
}

export function* setContentPermissions(action: SetContentPermissionsAction) {
  try {
    if(action.content.length < 1){
      throw new Error('setContentPermissions was called without any content');
    }

    const contentType = ExplorableItemDefinitions[action.content[0].contentType];
    let content = action.content;
    if (contentType.itemType === DatasourceDefinition.contentType) {
      content = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, content);
    }

    // TFS 815536: Re-fetching the projects is necessary to avoid stale lock statuses being shown
    // in the permissions dialog. If we implement lock status via source authorizables
    // (TFS 667457), we can remove this re-fetch.
    if (contentType.itemType === ProjectDefinition.contentType) {
      content = yield getProjectInfos(action.content);
    }

    // Make a graphql call to get locked status of databases
    if (contentType.itemType === DatabaseDefinition.itemType) {
      const idToDatabasesMap: {[id: string]: boolean;} = { };

      const databases = yield getDatabases(action.content);

      for (const database of databases) {
        idToDatabasesMap[database.id] = database.controlledPermissionsEnabled;
      }

      content = content.map(contentElement => { return {
          ...contentElement,
          controlledPermissionsEnabled: idToDatabasesMap[contentElement.id]
          };
        });
    }

    // Hack to use `vizportalId` field for Database & Table
    // TFS912863: Remove this hack once we switched to use vizportalId as primary ID for database & table
    if (contentType.itemType === TableDefinition.itemType || contentType.itemType === DatabaseDefinition.itemType) {
      content = content.map(contentElement => {return {...contentElement, id: contentElement.vizportalId};});
    }

    yield call(openPermissionsDialog, content, contentType.itemType);
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
